import { MailOutlined } from '@ant-design/icons';
import { App, Button, Card, Col, Form, Input, Layout, Row, Typography } from 'antd';
import { useState } from 'react';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../../config/firebase';
import { mouLightLogo } from '../../images/AppImages';
import { getFirebaseErrorMessage } from '../../utils/firebaseErrorMessages';

const { Title } = Typography;

const ForgotPasswordPage = () => {
    const [loading, setLoading] = useState(false);

    const { message } = App.useApp();

    const onFinish = (values: any) => {
        setLoading(true);
        sendPasswordResetEmail(auth, values.email)
            .then(() => {
                message.success('Se ha enviado un correo para restablecer la contraseña.');
                setLoading(false);
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = getFirebaseErrorMessage(errorCode);
                message.error(errorMessage);
                setLoading(false);
            });
    };

    return (
        <Layout style={{ height: '100vh' }}>
            <Row justify="center" align="middle" style={{ height: '100%' }}>
                <Col>
                    <Card style={{ width: 400 }}>
                        <div style={{ textAlign: 'center', marginBottom: 24 }}>
                            <img src={mouLightLogo} alt="Logo" style={{ height: 30 }} />
                        </div>
                        <Title level={3} style={{ textAlign: 'start', marginBottom: 24 }}>Olvidé la contraseña</Title>
                        <Form
                            name="forgotPasswordForm"
                            onFinish={onFinish}
                        >
                            <Form.Item
                                name="email"
                                rules={[{ required: true, message: 'Por favor, ingresa tu correo electrónico' }]}
                            >
                                <Input prefix={<MailOutlined />} placeholder="Correo electrónico" />
                            </Form.Item>
                            <Form.Item style={{ marginTop: 20 }}>
                                <Button type="primary" htmlType="submit" style={{ width: '100%' }} loading={loading}>
                                    Enviar correo de restablecimiento
                                </Button>
                            </Form.Item>
                        </Form>
                    </Card>
                </Col>
            </Row>
        </Layout>
    );
};

export default ForgotPasswordPage;
